/**
 * Synchronous input-draft use cases over an injected persistence boundary.
 * This layer deliberately owns neither browser storage nor draft state.
 *
 * @param {{ loadInputDraft: (idempotencyKey: any) => any, saveInputDraft: (idempotencyKey: any, draft: any) => void, clearInputDraft: (idempotencyKey: any) => void }} inputDraftRepository
 */
export function createInputDraftApplicationService({ inputDraftRepository }) {
  return {
    loadInputDraft: idempotencyKey => inputDraftRepository.loadInputDraft(idempotencyKey),
    saveInputDraft: (idempotencyKey, draft) => inputDraftRepository.saveInputDraft(idempotencyKey, draft),
    clearInputDraft: idempotencyKey => inputDraftRepository.clearInputDraft(idempotencyKey)
  }
}